module.exports = __webpack_public_path__ + "static/procesProdukcjaMobile@x2-95575d4860093a5fe5d71e46ab0cf4c7.png";